import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import Label from "../../common/components/Label";
import Recipients from "./Recipients";
import { contactGroupWith } from "../contactsModels";
import { createContactGroup, editContactGroup } from "../actions/saveContactGroup";
import { secondaryButtonStyles } from "../../common/styles";
import { isRequired, validateField, allContactEmailsAreValid } from "../../recorder/recorderValidations";
import { getContactGroup } from "../../recorder/recordingReducers";

const newGroupStyles = {
    background: "rgba(0,0,0,0.05)",
    padding: 10,
    borderRadius: "0 4px 4px 4px"
};

const errorColor = "#D0021B";
const requiredStyle = {
    color: errorColor
};
function styleIfRequired(field, style = requiredStyle) {
    if (field.error && field.touched) {
        return style;
    }

    return {};
}

export const ContactGroupEditor = (props) => (
    <div className="x-new-group" style={newGroupStyles}>
        <div className="pure-control-group">
            <Label style={{width: "4em", ...styleIfRequired(props.fields.name)}}>Name</Label>

            <input className="x-group-name"
                   {...props.fields.name}
                   placeholder="Name your contact group"
                   style={{width: 190, ...styleIfRequired(props.fields.name, { borderColor: errorColor })}} />
        </div>

        <div className="pure-control-group x-recipients">
            <div style={{ display: "inline-block" }}>
                <Label style={{
                    display: "block",
                    marginTop: 12,
                    width: "4em",
                    ...styleIfRequired(props.fields.contacts)
                }}>Contacts</Label>
            </div>

            <Recipients {...props.fields.contacts}
                        style={{
                           display: "inline-block",
                           width: 300,
                           verticalAlign: "top"
                        }}
                        inputStyle={{width: 300, ...styleIfRequired(props.fields.contacts, { borderColor: errorColor })}}
            />
        </div>

        <input type="button" className="button-as-link x-cancel" value="Cancel" onClick={props.onComplete} style={{marginLeft: 200}} />

        <button type="button"
                className="pure-button x-create-group"
                style={Object.assign({}, secondaryButtonStyles, {marginLeft: "1em"})}
                onClick={() => {
                    props.handleSubmit((values, dispatch) => submitThenResetForm(props, values, dispatch))();

                    if (!Object.keys(props.fields).some((key) => props.fields[key].error)){
                        props.onComplete();
                    }
                }} >Save</button>
    </div>
);

function submitThenResetForm(props, values, dispatch) {
    const contactGroup = contactGroupWith({ authorId: props.authorId, id: props.contactGroupId,  ...values });

    let result;
    if (props.contactGroupId) {
        result = editContactGroup(contactGroup, dispatch);
    } else {
        result = createContactGroup(contactGroup, dispatch);
    }

    return result.then(props.resetForm);
}

export function validate(fields) {
    const errors = {};

    fields.name = fields.name ? fields.name.trim() : null;
    validateField(fields, "name", errors, isRequired);

    validateField(fields, "contacts", errors, isRequired) &&
    validateField(fields, "contacts", errors, allContactEmailsAreValid);

    return errors;
}

const mapStateToProps = (state, ownProps) => {
    const blankContactGroup = { contacts: [] };
    const existingContactGroup = getContactGroup(state, ownProps.contactGroupId);
    return {
        authorId: state.authentication.authenticatedUser.userId,
        initialValues: existingContactGroup ? existingContactGroup : blankContactGroup
    }
};

export default reduxForm({
    form: "contactGroup",
    fields: [
        "name",
        "contacts"
    ],
    validate
}, mapStateToProps)(ContactGroupEditor);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/components/ContactGroupEditor.js
 **/